// extracted by mini-css-extract-plugin
export default {"main":"AcademiaSelector_main__8lwot"};